import { render, staticRenderFns } from "./TheBackToTopButton.vue?vue&type=template&id=25e99735&scoped=true"
import script from "./TheBackToTopButton.vue?vue&type=script&lang=js"
export * from "./TheBackToTopButton.vue?vue&type=script&lang=js"
import style0 from "./TheBackToTopButton.vue?vue&type=style&index=0&id=25e99735&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e99735",
  null
  
)

export default component.exports